export const EVENTS_SCHEMA_VERSION = "0.45.0";
export const PAGE_VIEWS_SCHEMA_VERSION = "0.21.0";
